export default {
  SET_PAGES(state, pages) {
    state.list = pages;
  }
};
